export const PRIVACY_POLICY_URL = 'https://www.sportspredict.com/privacy';
export const TERMS_AND_CONDITIONS_URL = 'https://www.sportspredict.com/terms';
export const CONTACT_URL = 'https://www.sportspredict.com/contact';
export const COOKIE__URL = 'https://www.sportspredict.com/cookies';
export const TERMS_URL = 'https://sportspredict.com/terms';
